export default __webpack_public_path__ + "assets/wind.7666ea56.svg";